import { Box, Typography } from '@mui/material'
import { motion } from 'framer-motion'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import AutorenewIcon from '@mui/icons-material/Autorenew'
import PauseCircleOutlineIcon from '@mui/icons-material/PauseCircleOutline'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos'

const meta = (p: number) => {
  if (p >= 100) return { label: 'SELESAI', icon: <CheckCircleIcon />, bg: '#22c55e' }
  if (p > 0) return { label: 'PROSES', icon: <AutorenewIcon />, bg: '#facc15' }
  return { label: 'BELUM MULAI', icon: <PauseCircleOutlineIcon />, bg: '#64748b' }
}

export default function ProductionTimeline({ steps }: { steps: any[] }) {
  return (
    <Box
      sx={{
        display: 'flex',
        gap: 4,
        p: 4,
        overflowX: 'auto',
        bgcolor: '#020617'
      }}
    >
      {steps.map((s, i) => {
        const p = Math.min(100, Math.max(0, Number(s.persen_hasil) || 0))
        const m = meta(p)

        return (
          <Box key={i} sx={{ display: 'flex', alignItems: 'center', gap: 3 }}>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              whileHover={{ scale: 1.06 }}
              style={{
                width: 260,
                padding: 24,
                borderRadius: 24,
                background: '#0f172a',
                color: '#fff',
                boxShadow: '0 15px 40px rgba(0,0,0,.7)'
              }}
            >
              <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Typography fontWeight={800}>{s.proses}</Typography>
                {m.icon}
              </Box>

              <Typography fontSize={36} fontWeight={900} mt={1}>
                {p}%
              </Typography>

              <Box sx={{ height: 8, bgcolor: '#1e293b', borderRadius: 4 }}>
                <Box
                  sx={{
                    width: `${p}%`,
                    height: '100%',
                    bgcolor: m.bg,
                    borderRadius: 4
                  }}
                />
              </Box>

              <Typography
                fontSize={12}
                mt={1}
                fontWeight={700}
                color={m.bg}
              >
                {m.label}
              </Typography>

              <Box sx={{ fontSize: 12, mt: 1, opacity: 0.8 }}>
                <div>Mulai: {s.tgl_realisasi || '-'}</div>
                <div>Selesai: {s.tgl_selesai || '-'}</div>
              </Box>
            </motion.div>

            {i < steps.length - 1 && (
              <ArrowForwardIosIcon sx={{ color: '#475569' }} />
            )}
          </Box>
        )
      })}
    </Box>
  )
}
